import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseService } from './Base.service';
import * as $ from 'jquery';
import { Common } from '../Utility/Common';
import { saveAs } from 'file-saver-es';

//import { CognitiveService } from './Cognitive.service';
import { environment } from 'src/environments/environment';
//import { PushNotificationService } from '../Component/Notification/PushNotification.service';
import { ToastService } from '../Component/Toast/Toast.service';
//import { FileDownload } from "capacitor-plugin-filedownload";
import { FileOpener } from '@capacitor-community/file-opener';
import { Capacitor, Plugins } from '@capacitor/core';
import { GlocationService } from './Glocation.service';
import { LoadingService } from '../Component/Loader/Loading.service';
import { LocationLoadingService } from '../Component/LocationLoader/LocationLoading.service';
import { PopupService } from '../Component/Popup/Popup.service';
import { GoogleMapCustomerService } from '../Component/GoogleMapCustomer/GoogleMapCustomer.service';
import { SHowCFPPService } from '../Component/ContactPopup/SHowCFPP.service';

@Injectable({ providedIn: 'root' })
export class CommonapiService extends BaseService {
  constructor(
    private zone: NgZone,
    private router: Router,
    public override httpClient: HttpClient,
    private toast: ToastService,
    private GLS: GlocationService,
    public loader: LoadingService,
    public locationloader: LocationLoadingService,
    public PopupService: PopupService,
    private gapi: GoogleMapCustomerService,
    public ContactPopupService: SHowCFPPService
  ) {
    super(httpClient);
  } //public CognitiveSer: CognitiveService,
  $ = $;

  GetCategory() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let _cat = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      _cat = _logindata.category;
    }
    return _cat;
  }

  GetDirection(lat,lng){
   let _loca:any= this.get_local_storage("sales_currentLocation", true);

   console.log("_loca",_loca)
   var  url ="";
   if(lat && lng && _loca.lat && _loca.long  ){
    //url ="https://www.google.es/maps/dir/'"+ lat +","+lng+"'/'"+ _loca.lat +","+_loca.long+"'";
    url ="https://www.google.es/maps/dir/'"+ _loca.lat +","+_loca.long+"'/'"+ lat +","+lng+"'";
   }else if(lat && lng){
    url = "https://maps.google.com/?q=" + lat + "," + lng;
   }
   //var url = "https://maps.google.com/?q=" + lat + "," + lng;

   console.log("url",url)
   window.open(url);
  }

  GetAdminRole() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let is_admin_role = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      is_admin_role = _logindata.is_admin_role;
    }
    return is_admin_role;
  }

  GetRetailSalesRoleId() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let retailSalesRoleId = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      retailSalesRoleId = _logindata.retail_sales_app_role_id;
    }
    return retailSalesRoleId;
  }

  GetTopAdmin() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let is_tops_admin = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      is_tops_admin = _logindata.is_tops_admin;
    }
    return is_tops_admin;
  }
  GetAppAdmin() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let is_app_admin = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      is_app_admin = _logindata.is_app_admin;
    }
    return is_app_admin;
  }
  GetAdmin() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let is_admin = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      is_admin = _logindata.is_admin;
    }
    return is_admin;
  }
  GetSupervisor() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let is_supervisor = 0;
    if (_logindata != '[]' && _logindata != undefined) {
      is_supervisor = _logindata.is_supervisor;
    }
    return is_supervisor;
  }
  GetisVerified() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isVerified = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isVerified = _logindata.isVerified;
    }
    return isVerified;
  }

  GetisHospitalAttributes() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isHospitalAttributes = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isHospitalAttributes = _logindata.isHospitalAttributes;
    }
    return isHospitalAttributes;
  }
  GetisSchoolAttributes() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isSchoolAttributes = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isSchoolAttributes = _logindata.isSchoolAttributes;
    }
    return isSchoolAttributes;
  }
  GetisAppointmentArea() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isAppointmentArea = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isAppointmentArea = _logindata.isAppointmentArea;
    }
    return isAppointmentArea;
  }
  GetisSalesHistory() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isSalesHistory = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isSalesHistory = _logindata.isSalesHistory;
    }
    return isSalesHistory;
  }
  GetisDeal() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isDeal = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isDeal = _logindata.isDeal;
    }
    return isDeal;
  }

   GetisEdit() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isEdit = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isEdit = _logindata.isEdit;
    }
    return isEdit;
  }

  GetisTeam() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isTeam = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isTeam = _logindata.isTeam;
    }
    return isTeam;
  }

  GetisBeats() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isBeats = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isBeats = _logindata.isBeats;
    }
    return isBeats;
  }

  GetisDealReport() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isDealReport = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isDealReport = _logindata.isDealReport;
    }
    return isDealReport;
  }

  GetisOrderReport() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isOrderReport = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isOrderReport = _logindata.isOrderReport;
    }
    return isOrderReport;
  }

  GetisOrderType() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isOrderType = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isOrderType = _logindata.isOrderType;
    }
    return isOrderType;
  }

  GetisHospitalReport() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isHospitalReport = false;
    if (_logindata != '[]' && _logindata != undefined) {
      isHospitalReport = _logindata.isHospitalReport;
    }
    return isHospitalReport;
  }

  GetisISRUser() {
    let _logindata: any = this.get_local_storage('sales_logindata', true);
    let isISR = false;
    if (_logindata != '[]' && _logindata != undefined) {

      if(_logindata.designation != null && _logindata.designation != '' && _logindata.designation != undefined)
      {
        if(_logindata.designation.toUpperCase() == 'ISR')
        {
          isISR = true;
        }

      }

    }
    return isISR;
  }

  ShowContatPoppup(customer_id,contact_list) {
    this.ContactPopupService.Show({ show: true,customer_id:customer_id,contact_list:contact_list });
  }

  ShowGMapCustomer(data) {
    this.gapi.Show(data);
  }
  SetLogin(obj) {
    localStorage.setItem('sales_token', obj);
  }
  isLoggedin() {
    let token = localStorage.getItem('sales_token');
    let data = this.get_local_storage('sales_logindata', true);
    if (data) {
      Common.login_info = data;
    }
    return token && token.length > 5 ? true : false;
  }
  getStudentInfo(id) {
    let data: any = this.get_local_storage('stud_det', true);
    let _stud = data.filter((x) => x.child_id == id);
    return _stud[0];
  }

  LocalStorageClear()
  {
    localStorage.clear();
  }

  async Logout(src = '') {
    let token: string = localStorage.getItem('sales_token');
    //console.log('token', token);
    localStorage.clear();

    this.router.navigateByUrl('/login?src=' + src, { replaceUrl: true })
    if(token!="" && token!= null && token.length>5 ){
     // localStorage.clear();
      var postdata = { token:token,  logId: '',    device_id: '',   url: environment.apiurl + this.router.url  };
      this.logoutapi(postdata, false).then((data) => {});
    }
  }

  async logoutapi(obj: any, isformupload: boolean) {
    return this.apiPost(false, `SalesEntry/LogoutV1`, obj, isformupload);
  }

  set_local_storage(alias, json, serialize = true) {
    if (typeof Storage !== 'undefined') {
      try {
        if (serialize) localStorage.setItem(alias, JSON.stringify(json));
        else localStorage.setItem(alias, json);
      } catch (error) {
        this.Logout('Storage');
      }
    }
    //  Common.log("call set_local_storage ")
  }
  get_local_storage(alias, serialize = true) {
    let val = '';
    if (typeof Storage !== 'undefined' && alias) {
      val = localStorage.getItem(alias);

      // Common.log("val",val)
      if (val && serialize) val = JSON.parse(val);
    }
    return val;
  }

  set_local_remove_storage(alias, json = '', serialize = true) {
    if (typeof Storage !== 'undefined') {
      try {
        localStorage.removeItem(alias);
      } catch (error) {
        this.Logout('Storage');
      }
    }
    //  Common.log("call set_local_storage ")
  }

  // Show_Toast(msg, autohide = true) {
  //   this.toast.Show(msg, autohide);
  // }

  Toast_alert(msg, autohide = true) {
    this.toast.alert(msg, autohide);
  }

  Toast_info(msg, show_close = true, autohide = true) {
    this.toast.info(msg, show_close, autohide);
  }

  Toast_success(msg, show_close = true, autohide = true) {
    this.toast.success(msg, show_close, autohide);
  }

  // Hide_Toast() {
  //   this.toast.Hide();
  // }

  async getLocation() {
    return await this.GLS.getLocation();
  }

  showpopup(data) {
    this.PopupService.Show(data);
  }
}
